import { Icon } from "@rentiohq/web-shared/dist/components";
import React from "react";
import { EAcademyChapter, IAcademySection } from "../../RentmatchAcademy.types";
import {
  getAcademyText,
  getSectionAnchor,
  getSectionKey,
  getUiKey,
} from "../../RentmatchAcademy.utils";
import { AcademyHighlight } from "../AcademyHighlight";
import { AcademyText } from "../AcademyText";
import * as S from "./AcademyFaq.styles";

interface IAcademyFaqProps {
  chapterId: EAcademyChapter;
  sections: IAcademySection[];
  // The question a search result points at: it opens, with the search marked.
  openSectionId?: string;
  query?: string;
}

// A question list: one answer open at a time, so opening the next question
// closes the previous one.
export const AcademyFaq = ({
  chapterId,
  sections,
  openSectionId,
  query,
}: IAcademyFaqProps) => {
  // State
  const [openId, setOpenId] = React.useState(openSectionId);

  // Event handlers
  const handleToggle = (sectionId: string) =>
    setOpenId(current => (current === sectionId ? undefined : sectionId));

  // Render
  return (
    <S.List>
      {sections.map(section => {
        const isOpen = openId === section.id;
        const panelId = `academy-faq-${chapterId}-${section.id}`;
        const sectionQuery = section.id === openSectionId ? query : undefined;

        return (
          <React.Fragment key={`${chapterId}-${section.id}`}>
            {section.group && (
              <S.Group>
                {getAcademyText(getUiKey(`faq.group.${section.group}`))}
              </S.Group>
            )}
            <S.Item id={getSectionAnchor(chapterId, section.id)}>
              <S.Question
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => handleToggle(section.id)}
              >
                <span>
                  <AcademyHighlight
                    text={getAcademyText(
                      getSectionKey(chapterId, section.id, "title"),
                    )}
                    query={sectionQuery}
                  />
                </span>
                <Icon
                  source={isOpen ? "chevronUp" : "chevronDown"}
                  size="small"
                />
              </S.Question>
              {isOpen && (
                <S.Answer id={panelId}>
                  <AcademyText
                    text={getAcademyText(
                      getSectionKey(chapterId, section.id, "body"),
                    )}
                    query={sectionQuery}
                  />
                </S.Answer>
              )}
            </S.Item>
          </React.Fragment>
        );
      })}
    </S.List>
  );
};
